import React from 'react'
import { Link, useNavigate } from 'react-router'
import { Box, Container, Typography } from "@mui/material";
import { PRIMARY_BUTTON_BLUE } from "../colorPalette";
import RoundedFilledButton from '../components/RoundedFilledButton';

function ErrorPage() {
  const navigate = useNavigate()

  return (
    <div>
        <Container
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100vh", // Full viewport height
                        textAlign: "center",
                    }}
                >
                    <Typography variant="h1" sx={{flexDirection: 'row'}} fontWeight={500} color={PRIMARY_BUTTON_BLUE}>404</Typography>
                    <Typography variant="h3" gutterBottom sx={{flexDirection: 'row'}} fontWeight={400}>Page Not Found</Typography>
                    <Typography variant="body1">
                        Sorry, the page you are looking for does not exist.  
                    </Typography>
                    <Box sx={{height: '200px', width: '200px', 
                      backgroundImage: `url("/SadHeart.png")`,
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center',
                      backgroundSize: 'cover'}}></Box>
                    <RoundedFilledButton onClick={() => navigate('/')}>Go to Homepage</RoundedFilledButton>
                </Container>
    </div>
  )
}

export default ErrorPage

// import React from 'react'
// import { Link } from 'react-router-dom'

// function ErrorPage() {
//   return (
//     <div>
//         <h1>404 Not Found</h1>
//         <Link to="/">Go back to the main page</Link>
//     </div>
//   )
// }

// export default ErrorPage